import { render, staticRenderFns } from "./InterestRewardEditor.vue?vue&type=template&id=f49e12ee&scoped=true"
import script from "./InterestRewardEditor.vue?vue&type=script&lang=ts"
export * from "./InterestRewardEditor.vue?vue&type=script&lang=ts"
import style0 from "./InterestRewardEditor.vue?vue&type=style&index=0&id=f49e12ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49e12ee",
  null
  
)

export default component.exports